module.exports = __webpack_public_path__ + "static/img/404_bg.a57b6f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/404_bg.png
// module id = 0g1H
// module chunks = 10